module.exports = __webpack_public_path__ + "static/img/culture_2.19349d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/culture_2.png
// module id = O2pC
// module chunks = 1